<script setup>
import {defineAsyncComponent, reactive, ref} from 'vue'
import SlideUpDown from 'vue-slide-up-down'
import PopperIcon from "../PopperIcon.vue";
import mitt from "mitt";
import SmallModal from "../modal/SmallModal.vue";
import {useModal, useModalSlot} from "vue-final-modal";
import DefaultModal from "../modal/DefaultModal.vue";
// import Popper from 'vue3-popper'

const emitter = mitt()

const props = defineProps([
    'data',
    'jobLink',
    'jobTranslations',
    'defaultContactImage',
    'specificJobId'
])

const state = reactive({
    open: props.specificJobId ? true : false,
})

function checkIssetOfferAttribute(attributeName) {
    return (
        props.data &&
        props.data.data &&
        props.data.data.offer &&
        props.data.data.offer[attributeName] !== undefined
    );
}

function checkIssetProjectAttribute(attributeName) {
    return (
        props.data &&
        props.data.data &&
        props.data.data.project &&
        props.data.data.project[attributeName] !== undefined
    );
}

function checkIfOfferAttributeChecked(attributeName) {
    return (
        props.data &&
        props.data.data &&
        props.data.data.offer &&
        (props.data.data.offer[attributeName] !== "" && props.data.data.offer[attributeName] !== "0" && props.data.data.offer[attributeName] !== 0 && props.data.data.offer[attributeName] !== false && props.data.data.offer[attributeName] !== "false")
    );
}

const { open, close, patchOptions } = useModal({
    component: DefaultModal,
    attrs: {
        //title: 'Vytvoriť udalosť',
        onClose() { close() },
    },
    slots: {
        default: useModalSlot({
            component: DefaultModal,
            attrs: {
                content: null,
            }
        }),
    },
})

const openSmallModal = (cnt) => {
    patchOptions({
        slots: {
            default: useModalSlot({
                component: SmallModal,
                attrs: {
                    content: cnt,
                }
                //props: { content: cnt, other:'ooo' },
            }),
        },
    });
    open();
};

function fixPhone($number) {
    if ($number.startsWith('421')) {
        return '+' + $number;
    }
    return $number;
}
function fixViberPhone($number) {
    if ($number.startsWith('421')) {
        return '%2B' + $number;
    }
    return $number;
}

function displayText(event) {
    let a = event.target.nextElementSibling;
    if (a.style.display === 'inline-block') {
        a.style.display = 'none';
        event.target.classList.add('glowing');
    } else {
        a.style.display = 'inline-block';
        event.target.classList.remove('glowing');
    }
}
</script>

<template>
    <li class="job-finder__list-item" v-if="data">
        <div class="title" :class="{ 'open': state.open }"
             @click="!specificJobId ? state.open = !state.open : null"
        >
            <div class="left">
                <div class="description">
                    <h6>
                        {{ data.name }}
                    </h6>
                    <template v-if="checkIssetOfferAttribute('interna_pozicia') && checkIfOfferAttributeChecked('interna_pozicia')">
                        <p class="internal-badge">{{ jobTranslations['Ponuka - Interná pozícia (značka)'] }}</p>
                    </template>
                </div>
                <div class="list-icons hidden-lg-down">
                    <div class="icon-column" v-if="checkIssetOfferAttribute('zabezpecena_doprava') && checkIfOfferAttributeChecked('zabezpecena_doprava')">
                        <PopperIcon
                            icon-src="/img/icons/bus.svg"
                            :content="jobTranslations['Ponuka - áno (benefit doprava)']"
                            class="dark-popper-theme"
                            hover-color="#38C975"
                        />
                    </div>
                    <div class="icon-column" v-if="checkIssetOfferAttribute('zabezpecene_ubytovanie') && checkIfOfferAttributeChecked('zabezpecene_ubytovanie')">
                        <PopperIcon
                            icon-src="/img/icons/house.svg"
                            :content="jobTranslations['Ponuka - áno (benefit ubytovanie)']"
                            class="dark-popper-theme"
                            hover-color="#3F97EF"
                        />
                    </div>
                    <div class="icon-column">
                        <PopperIcon
                            icon-src="/img/icons/euro.svg"
                            :content="jobTranslations['Ponuka - (benefit zálohy)']"
                            class="dark-popper-theme"
                            hover-color="#FF0101"
                        />
                    </div>
                </div>
            </div>
            <div class="right">
                <div class="tags">
                    <div class="c-tag" v-if="checkIssetOfferAttribute('top_ponuka') && checkIfOfferAttributeChecked('top_ponuka')" style="color: #fff; background-color: #D62828; display: flex;flex-wrap: nowrap;white-space: nowrap;width: auto;">
                        <img src="/img/icons/fire.svg" :alt="jobTranslations['Ponuka - štítok (top ponuka)']">
                        {{ jobTranslations['Ponuka - štítok (top ponuka)'] }}
                    </div>
                    <div class="c-tag" v-else-if="checkIssetOfferAttribute('najziadanejsia_ponuka') && checkIfOfferAttributeChecked('najziadanejsia_ponuka')" style="color: #fff; background-color: #EE8E1D; display: flex;flex-wrap: nowrap;white-space: nowrap;width: auto;">
                        <img src="/img/icons/fire.svg" :alt="jobTranslations['Ponuka - štítok (najžiadanejšia ponuka)']">
                        {{ jobTranslations['Ponuka - štítok (najžiadanejšia ponuka)'] }}
                    </div>
                    <div v-if="data.salary && data.salary > 0" class="c-tag" style="color: #0C0C0C; background-color: #fff; border-color: #38C976; display: flex;flex-wrap: nowrap;white-space: nowrap;width: auto;">
                        <img src="/img/icons/money.svg" :alt="data.salary">
                        {{ data.salary }} <template v-if="checkIssetOfferAttribute('mena')">{{data.data.offer.mena}}</template><template v-else>{{ jobTranslations['Ponuka - default mena'] }}</template>
                    </div>
                </div>
                <div class="list-icons hidden-lg-up">
                    <div class="icon-column" v-if="checkIssetOfferAttribute('zabezpecena_doprava') && checkIfOfferAttributeChecked('zabezpecena_doprava')">
                        <PopperIcon
                            icon-src="/img/icons/bus.svg"
                            :content="jobTranslations['Ponuka - áno (benefit doprava)']"
                            class="dark-popper-theme"
                            hover-color="#38C975"
                        />
                    </div>
                    <div class="icon-column" v-if="checkIssetOfferAttribute('zabezpecene_ubytovanie') && checkIfOfferAttributeChecked('zabezpecene_ubytovanie')">
                        <PopperIcon
                            icon-src="/img/icons/house.svg"
                            :content="jobTranslations['Ponuka - áno (benefit ubytovanie)']"
                            class="dark-popper-theme"
                            hover-color="#3F97EF"
                        />
                    </div>
                    <div class="icon-column">
                        <PopperIcon
                            icon-src="/img/icons/euro.svg"
                            :content="jobTranslations['Ponuka - (benefit zálohy)']"
                            class="dark-popper-theme"
                            hover-color="#FF0101"
                        />
                    </div>
                </div>
                <button v-if="!specificJobId" type="button" class="hidden-lg-down" :aria-label="state.open ? 'close' : 'open'">
                    <img src="/img/icons/angle-right.svg" :alt="data.name">
                </button>
            </div>
        </div>
        <slide-up-down :active="state.open" :duration="1000">
            <div class="content" v-if="state.open">
                <div class="content-left">

                    <!--
                        TODO: Andrej - kontroly ako checkIssetOfferAttribute nefunguje spravne vrati true
                        TODO: ak je tam prazdny string a vypise sa <p></p>
                    -->

                    <h4 class="subtitle">{{ jobTranslations['Ponuka - náplň práce (nadpis)'] }}</h4>
                    <p v-if="checkIssetOfferAttribute('short_description')" v-html="data.data.offer.short_description"></p>
                    <p v-if="checkIssetOfferAttribute('other_informations')" v-html="data.data.offer.other_informations"></p>
                    <p v-if="checkIssetOfferAttribute('job_offer_information')" v-html="data.data.offer.job_offer_information"></p>

                    <h4 class="subtitle">{{ jobTranslations['Ponuka - zamestnanecké výhody (nadpis)'] }}</h4>
                    <p v-if="checkIssetOfferAttribute('benefits')" v-html="data.data.offer.benefits"></p>

                    <h4 class="subtitle">{{ jobTranslations['Ponuka - zamestnanecké výhody transfer (nadpis)'] }}</h4>
                    <p v-if="checkIssetOfferAttribute('transfer_vyhody')" v-html="data.data.offer.transfer_vyhody"></p>

                    <h4 class="subtitle">{{ jobTranslations['Ponuka - osobnostné predpoklady (nadpis)'] }}</h4>
                    <p v-if="checkIssetOfferAttribute('personality_assumptions_skills') && data.data.offer.personality_assumptions_skills">
                        <span v-html="data.data.offer.personality_assumptions_skills"></span>
                    </p>

                    <!--<h4 class="subtitle">{{ jobTranslations['Ponuka - absolvent (nadpis)'] }}</h4>
                    <p v-if="checkIssetOfferAttribute('pracovna_ponuka_vhodna_pre_absolventa')" style="font-size: 1rem;">
                        {{ checkIfOfferAttributeChecked('pracovna_ponuka_vhodna_pre_absolventa') ? jobTranslations['Ponuka - áno (absolvent)'] : jobTranslations['Ponuka - nie (absolvent)']}}
                    </p>-->

                    <a v-if="!specificJobId" :href="jobLink + '/' + data.slug" class="mt-3 hidden-md-up">
                        <button type="button" class="c-button c-button--secondary" :aria-label="jobTranslations['Ponuka - detail (nápis)']">
                            {{jobTranslations['Ponuka - detail (nápis)']}}
                            <svg width="17px" height="18px">
                                <use href="/img/icons/icons.svg#btnArrow"></use>
                            </svg>
                        </button>
                    </a>

                </div>
                <div class="content-right">
                    <template v-if="data.contact">
                        <div class="hidden-md-down">
                            <figure>
                                <picture>
                                    <img :src="data.contact.photo && data.contact.photo.original_url ? data.contact.photo.original_url : defaultContactImage" loading="lazy" :alt="data?.contact?.name">
                                </picture>
                            </figure>
                            <p v-if="data.contact.name"><strong>{{ data.contact.name }}</strong></p>
                            <h5 v-if="data.contact.data && JSON.parse(data.contact.data).pracovna_pozicia" class="mt-2" style="font-weight: 500;">{{ JSON.parse(data.contact.data).pracovna_pozicia }}</h5>
                            <div class="actions">
                                <template v-if="data.contact.phone">
                                    <a :href="'tel:'+fixPhone(data.contact.phone)" class="contact-icon phone-icon" aria-label="Phone">
                                        <svg width="19px" height="18px">
                                            <use href="/img/icons/icons.svg#phone"></use>
                                        </svg>
                                    </a>
                                </template>
                                <template v-if="data.contact.email">
                                    <a :href="'mailto:'+data.contact.email" class="contact-icon email-icon" aria-label="Email">
                                        <img src="/img/icons/mail.svg" alt="email">
                                    </a>
                                </template>
                                <template v-if="data.contact.phone">
                                    <a :href="'viber://chat/?number='+fixViberPhone(data.contact.phone)" class="contact-icon viber-icon" aria-label="Viber">
                                        <svg width="26px" height="26px">
                                            <use href="/img/icons/icons.svg#viber"></use>
                                        </svg>
                                    </a>
                                    <a :href="'https://web.whatsapp.com/send?phone='+fixPhone(data.contact.phone)" class="contact-icon whatsapp-icon hidden-md-down" aria-label="WhatsApp">
                                        <svg width="21px" height="20px">
                                            <use href="/img/icons/icons.svg#whatsapp"></use>
                                        </svg>
                                    </a>
                                    <a :href="'https://api.whatsapp.com/send?phone='+fixPhone(data.contact.phone)" class="contact-icon whatsapp-icon hidden-md-up" aria-label="WhatsApp">
                                        <svg width="21px" height="20px">
                                            <use href="/img/icons/icons.svg#whatsapp"></use>
                                        </svg>
                                    </a>
                                </template>
                                <template v-if="data.contact.data && JSON.parse(data.contact.data).user_name_messenger">
                                    <a :href="'https://m.me/'+JSON.parse(data.contact.data).user_name_messenger" class="contact-icon messenger-icon" aria-label="Messenger">
                                        <img src="/img/icons/messenger.svg" alt="messenger">
                                    </a>
                                </template>
                            </div>
                            <a v-if="data.contact.data && data.contact.data.map_url" :href="data.contact.data.map_url" class="map-link" target="_blank">
                                {{jobTranslations['Ponuka - zobraziť na mape (nápis)']}}
                            </a>
                        </div>
                    </template>

                    <a :href="jobLink + '?job-id=' + data.recru_offer_id" class="hidden-md-down">
                        <button type="button" class="c-button c-button--primary" :aria-label="jobTranslations['Ponuka - požiadať (nápis)']">
                            {{jobTranslations['Ponuka - požiadať (nápis)']}}
                            <svg width="17px" height="18px">
                                <use href="/img/icons/icons.svg#btnArrow"></use>
                            </svg>
                        </button>
                    </a>

                    <div class="box-info mt-4"
                         v-if="
                                (checkIssetOfferAttribute('locality') && data.data.offer.locality) ||
                                (checkIssetOfferAttribute('typ_zamestnania')) ||
                                (checkIssetOfferAttribute('nastupny_termin') && data.data.offer.nastupny_termin)
                            "
                    >
                        <template v-if="checkIssetOfferAttribute('locality') && data.data.offer.locality">
                            <div class="text-block">
                                <h6>{{ jobTranslations['Ponuka - miesto práce (nadpis)'] }}</h6>
                                <p>{{ data.data.offer.locality }}</p>
                            </div>
                        </template>
                        <template v-if="checkIssetOfferAttribute('typ_zamestnania')">
                           <div class="text-block">
                               <h6>{{ jobTranslations['Ponuka - druh pracovného pomeru (nadpis)'] }}</h6>
                               <template v-for="(work_type,index) in data.data.offer.typ_zamestnania">
                                   <p>{{ work_type }}{{ index !== data.data.offer.typ_zamestnania.length - 1 ? ', ' : '' }}</p>
                               </template>
                           </div>
                        </template>
                        <template v-if="checkIssetOfferAttribute('nastupny_termin') && data.data.offer.nastupny_termin">
                           <div class="text-block">
                               <h6>{{ jobTranslations['Ponuka - nástupný termín (nadpis)'] }}</h6>
                               <p>{{ data.data.offer.nastupny_termin }}</p>
                           </div>
                        </template>

                        <div class="text-block"
                             v-if="
                                checkIssetOfferAttribute('viac_informacii_o_mzde') && data.data.offer.viac_informacii_o_mzde ||
                                (checkIssetOfferAttribute('modal_mzdy') && data.data.offer.modal_mzdy)
                            "
                        >
                            <template v-if="checkIssetOfferAttribute('viac_informacii_o_mzde') && data.data.offer.viac_informacii_o_mzde">
                                <h6>{{ jobTranslations['Ponuka - mzdové podmienky (nadpis)'] }}</h6>
                                <div v-html="data.data.offer.viac_informacii_o_mzde"></div>
                            </template>
                            <template v-if="checkIssetOfferAttribute('modal_mzdy') && data.data.offer.modal_mzdy">
                                <a type="button" @click="openSmallModal(data.data.offer.modal_mzdy)" class="c-tag mt-3">
                                    {{jobTranslations['Ponuka - viac info (nápis)']}}
                                </a>
                            </template>
                        </div>
                    </div>

                    <a v-if="!specificJobId" :href="jobLink + '/' + data.slug" class="hidden-md-down">
                        <button type="button" class="c-button c-button--secondary" :aria-label="jobTranslations['Ponuka - detail (nápis)']">
                            {{jobTranslations['Ponuka - detail (nápis)']}}
                            <svg width="17px" height="18px">
                                <use href="/img/icons/icons.svg#btnArrow"></use>
                            </svg>
                        </button>
                    </a>

                    <template v-if="data.contact">
                        <div class="m-3 hidden-md-up">
                            <figure>
                                <picture>
                                    <img :src="data.contact.photo && data.contact.photo.original_url ? data.contact.photo.original_url : defaultContactImage" loading="lazy" :alt="data?.contact?.name">
                                </picture>
                            </figure>
                            <p v-if="data.contact.name"><strong>{{ data.contact.name }}</strong></p>
                            <h5 v-if="data.contact.data && JSON.parse(data.contact.data).pracovna_pozicia" class="mt-2" style="font-weight: 500;">{{ JSON.parse(data.contact.data).pracovna_pozicia }}</h5>

                            <div class="actions justify-content-center pt-4">
                                <template v-if="data.contact.phone">
                                    <a :href="'tel:'+fixPhone(data.contact.phone)" class="contact-icon phone-icon" aria-label="Phone">
                                        <svg width="19px" height="18px">
                                            <use href="/img/icons/icons.svg#phone"></use>
                                        </svg>
                                    </a>
                                </template>
                                <template v-if="data.contact.email">
                                    <a :href="'mailto:'+data.contact.email" class="contact-icon email-icon" aria-label="Email">
                                        <img src="/img/icons/mail.svg" alt="email">
                                    </a>
                                </template>
                                <template v-if="data.contact.phone">
                                    <a :href="'viber://chat/?number='+fixViberPhone(data.contact.phone)" class="contact-icon viber-icon" aria-label="Viber">
                                        <svg width="26px" height="26px">
                                            <use href="/img/icons/icons.svg#viber"></use>
                                        </svg>
                                    </a>
                                    <a :href="'https://web.whatsapp.com/send?phone='+fixPhone(data.contact.phone)" class="contact-icon whatsapp-icon hidden-md-down" aria-label="WhatsApp">
                                        <svg width="21px" height="20px">
                                            <use href="/img/icons/icons.svg#whatsapp"></use>
                                        </svg>
                                    </a>
                                    <a :href="'https://api.whatsapp.com/send?phone='+fixPhone(data.contact.phone)" class="contact-icon whatsapp-icon hidden-md-up" aria-label="WhatsApp">
                                        <svg width="21px" height="20px">
                                            <use href="/img/icons/icons.svg#whatsapp"></use>
                                        </svg>
                                    </a>
                                </template>
                                <template v-if="data.contact.data && JSON.parse(data.contact.data).user_name_messenger">
                                    <a :href="'https://m.me/'+JSON.parse(data.contact.data).user_name_messenger" class="contact-icon messenger-icon" aria-label="Messenger">
                                        <img src="/img/icons/messenger.svg" alt="messenger">
                                    </a>
                                </template>
                            </div>

                            <a v-if="data.contact.data && data.contact.data.map_url" :href="data.contact.data.map_url" class="map-link" target="_blank">
                                {{jobTranslations['Ponuka - zobraziť na mape (nápis)']}}
                            </a>
                        </div>
                    </template>
                    <a :href="jobLink + '?job-id=' + data.recru_offer_id" class="mt-3 hidden-md-up">
                        <button type="button" class="c-button c-button--primary" :aria-label="jobTranslations['Ponuka - požiadať (nápis)']">
                            {{jobTranslations['Ponuka - požiadať (nápis)']}}
                            <svg width="17px" height="18px">
                                <use href="/img/icons/icons.svg#btnArrow"></use>
                            </svg>
                        </button>
                    </a>
                </div>
            </div>
        </slide-up-down>
    </li>
</template>
